// src/types/housekeeping/HousekeepingAttention.ts
var HousekeepingAttentionKind = /* @__PURE__ */ ((HousekeepingAttentionKind2) => {
  HousekeepingAttentionKind2["RoomOutOfOrderWithBookings"] = "room_out_of_order_with_bookings";
  HousekeepingAttentionKind2["ArrivalRoomNotReady"] = "arrival_room_not_ready";
  return HousekeepingAttentionKind2;
})(HousekeepingAttentionKind || {});

export {
  HousekeepingAttentionKind
};
